import { EntryItem } from '@com-delta-omnichannel/aura';
import { Snapshot } from '../models/snapshot.interfaces';

export const ToggleTitleMocks: EntryItem = {
  content: {
    title: 'Recent Account Activity',
    subtitle: ''
  },
  state: '',
  icon: '',
  value: [
    {
      amount: '',
      currency: ''
    }
  ],
  border: 'none',
  ariaLabel: {
    icon: ''
  }
};

export const SnapshotEntryItemMocks: Snapshot = {
  title: 'Your Account Snapshot',
  toggle: ToggleTitleMocks,
  activities: [
    {
      content: {
        title: 'BWI<span class="separator"></span>ATL',
        subtitle: ''
      },
      state: '',
      icon: '',
      dateColumn: {
        month: 'DEC',
        date: '16'
      },
      value: [
        {
          amount: '463',
          currency: 'Miles'
        },
        {
          amount: '$866',
          currency: 'MQDs'
        }
      ],
      border: 'none',
      ariaLabel: {
        icon: ''
      }
    },
    {
      content: {
        title: 'Amex Platinum - 2X Miles Restaurants',
        subtitle: ''
      },
      state: '',
      icon: '',
      dateColumn: {
        date: '28',
        month: 'NOV'
      },
      value: [
        {
          amount: '400',
          currency: 'Miles'
        },
        {
          amount: '$800',
          currency: 'MQDs'
        }
      ],
      border: 'none',
      ariaLabel: {
        icon: ''
      }
    }
  ],
  action: {
    label: 'View All Your Activities',
    url: '/acctactvty/manageacctactvty.action'
  },
  disabled: false,
  loaded: true
};
